
$(document).ready(function(){
	
	$(".registrant_type").on("click", function() {
		if ($(this).val() == "trade") {
			$("tr#name").show();
			$("tr#email").show();
			$("tr#job").show().find("td.q").removeClass("required");
			$("tr#company").show().find("td.q").removeClass("required");
			$("tr#website").show();
			$("tr#school").hide();
			$("tr#graddate").hide();
			$("tr#telephone").hide();
			$("tr#address1").show();
			$("tr#address2").show();
			$("tr#city").show();
			$("tr#state").show();
			$("tr#zip").show();

		} else if ($(this).val() == "consumer") {
			$("tr#name").show();
			$("tr#email").show();
			$("tr#job").hide().find("td.q").addClass("required");
			$("tr#company").show().find("td.q").removeClass("required");
			$("tr#website").hide();
			$("tr#school").hide();
			$("tr#graddate").hide();
			$("tr#telephone").hide();
			$("tr#address1").show();
			$("tr#address2").show();
			$("tr#city").show();
			$("tr#state").show();
			$("tr#zip").show();

		} else if ($(this).val() == "media") {
			$("tr#name").show();
			$("tr#email").show();
			$("tr#job").show().find("td.q").removeClass("required");
			$("tr#company").show().find("td.q").addClass("required");
			$("tr#website").hide();
			$("tr#school").hide();
			$("tr#graddate").hide();
			$("tr#telephone").show();
			$("tr#address1").show();
			$("tr#address2").show();
			$("tr#city").show();
			$("tr#state").show();
			$("tr#zip").show();

		} else if ($(this).val() == "student") {
			$("tr#name").show();
			$("tr#email").show();
			$("tr#job").hide().find("td.q").addClass("required");
			$("tr#company").hide().find("td.q").addClass("required");
			$("tr#website").hide();
			$("tr#school").show();
			$("tr#graddate").show();
			$("tr#telephone").hide();
			$("tr#address1").show();
			$("tr#address2").show();
			$("tr#city").show();
			$("tr#state").show();
			$("tr#zip").show();
		}
	});

	$(".registrant_type:checked").trigger("click");
});

